import { $post, $get, $JsonPost } from '@/utils/axios-request';
// const base = '/vte';
import { vte } from '@/utils/axios-request/index';

const base = '';
class Vocabulary {
  // login
//   public async login(postData: any): Promise<any> {
//     return await $JsonPost('/ebopo/buser/api/v1/login', postData);
//   }
  // // 查询课程词汇数量
  // public async getWordNum(postData: any): Promise<any> {
  //   return await $get(vte + '/word/api/v1/getWordNum', postData);
  // }
  //  获取词量表
  // public async getWordsTable(postData: any): Promise<any> {
  //   return await $get(vte + '/course/api/v1/getWordsTable', postData);
  // }
  // 词汇登录 /ebopo/userStudy/api/v1/getUserInfo
  public async getStudentInfo(postData: any): Promise<any> {
    return await $get(`${vte}/studentStudy/api/v1/getStudentInfo`, postData);
  }

  // 课程设置接口
  public async courseConfiguration(postData: any): Promise<any> {
    return await $JsonPost(`${vte}/course/api/v1/courseConfiguration`, postData);
  }

  // 查看词关系词
  public async getWordRelative(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getWordRelative`, postData);
  }

  // 口语测评
  public async getTTSToken(postData: any): Promise<any> {
    return await $post(`${vte}/voice/api/v1/token/1`, postData);
  }

  // 新的词汇登录
  public async newGetStudentInfo(postData: any): Promise<any> {
    return await $get(`${vte}/userStudy/api/v1/getUserInfo`, postData);
  }

  //  新的获取词量表
  public async getWordsTable(postData: any): Promise<any> {
    return await $get(`${vte}/course/api/v1/getWordsTable`, postData);
  }

  // 新的查询课程词汇数量
  public async getWordNum(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getWordNum`, postData);
  }

  // 学生测试-获取最近一次测试得分
  public async getLastTest(postData: any): Promise<any> {
    return await $get(`${vte}/userTest/api/v1/getLastTest`, postData);
  }

  // 获取首页展示6/10词列表
  public async getHomeWordList(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getHomeWordList`, postData);
  }

  // 获取学生对于该课程各项排序
  public async getStudingWordsList(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getStudingWordsList`, postData);
  }

  // 获取首页展示6/10词列表
  public async getCheckIsNeedTest(postData: any): Promise<any> {
    return await $get(`${vte}/userTest/api/v1/getCheckIsNeedTest`, postData);
  }

  // 获取是否弹出总复习提示
  public async getFinishedFlag(postData: any): Promise<any> {
    return await $get(`${vte}/userStudy/api/v1/getFinishedFlag`, postData);
  }

  // 获取是否有新留言
  public async getWordStatus(): Promise<any> {
    return await $get(`${vte}/api/guestBook/getStatus`);
  }

  // 阅读-统计学习次数
  public async getReadCount(postData: any): Promise<any> {
    return await $get(`${vte}/redread/api/v1/addCount`, postData);
  }
}
export default new Vocabulary();
